import { render, staticRenderFns } from "./editIntegralExchange.vue?vue&type=template&id=6c914a7c&scoped=true"
import script from "./editIntegralExchange.vue?vue&type=script&lang=js"
export * from "./editIntegralExchange.vue?vue&type=script&lang=js"
import style0 from "./editIntegralExchange.vue?vue&type=style&index=0&id=6c914a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c914a7c",
  null
  
)

export default component.exports